export const environment = {
    production: false,
    // DEV ENVIRONMENT
    apiBaseUrl: 'https://preprod02.hezkytech.com/admin/api/',
    authBaseUrl: 'https://preprod02.hezkytech.com/auth/',
    customerApiBaseUrl: 'https://preprod02.hezkytech.com/customer/',
    userApiBaseUrl: 'https://preprod02.hezkytech.com/user/',
    logsUrl: 'https://preprod02.hezkytech.com/device/',

    // LOCAL ENVIRONMENT 
    // apiBaseUrl: 'http://localhost:9000/api/',
    // authBaseUrl: 'http://localhost:5191/',
    // customerApiBaseUrl: 'http://localhost:3113/',
    // userApiBaseUrl: 'http://localhost:3117/',
    // logsUrl: 'http://localhost:3333/',

    loginSuccess: '/customer',
    loginFailure: '/login',
};
